import React from "react";
import { useNavigate } from "react-router-dom";
import { ChartLine, PlusCircle, History } from "lucide-react";
import styles from './Dashboard.module.css';

// DashboardCard component updated to use module.css
const DashboardCard = ({ title, description, icon: Icon, color, onClick }) => {
  return (
    <div
      className={`${styles.dashboardCard} ${styles.animatedCard}`}
      onClick={onClick}
    >
      <div
        className={`${styles.cardBody} d-flex flex-column align-items-center text-center`}
        style={{
          backgroundColor: color,
          color: "white",
        }}
      >
        <Icon size={48} />
        <h5 className={styles.cardTitle}>{title}</h5>
        <p className={styles.cardText}><b>{description}</b></p>
      </div>
    </div>
  );
};

const Dashboard = () => {
  const navigate = useNavigate();

  // Dashboard items specifically for DSA Lender
  const dashboardItems = [
    {
      title: "Create Event Using Filter",
      description: "Create event using search available cars in the inventory",
      icon: PlusCircle,
      path: "/vehicleSelectionEventCreation",
      color: "#0263cc", // Green
    },
    {
      title: "Manage Events",
      description: "View and manage all events",
      icon: History,
      path: "/lenderEvent",
      color: "rgb(0, 176, 80)", // Blue
    },
    // {
    //   title: "Metrics Dashboard",
    //   description: "View analytics, reports, and overview",
    //   icon: ChartLine,
    //   path: "/master-dashboard",
    //   color: "rgb(255, 0, 0)", // Indigo
    // },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h5 className={styles.title}>Welcome to eBidding Dashboard</h5>

        <div className={styles.dashboardCards}>
          {dashboardItems.map((item) => (
            <DashboardCard
              key={item.path}
              title={item.title}
              description={item.description}
              icon={item.icon}
              color={item.color}
              onClick={() => navigate(item.path)}
            />
          ))}
        </div>        
      </div>
    </div>
  );
};

export default Dashboard;
